var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwinLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 79.57h176.006V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F60",
    d: "M42.185 23.246L23.215.22C22.84-.23 22.11.062 22.15.646l1.56 22.302-13.853-11.88c-.445-.38-1.115.034-.974.603L14.36 33.7 1.067 25.85c-.504-.297-1.092.228-.854.763l23.337 52.6c.24.54 1.03.446 1.14-.134l5.072-26.99 12.96-21.956c1.29-2.18 1.074-4.94-.537-6.894z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E74030",
    d: "M23.552 22.948L9.698 11.068c-.444-.38-1.115.034-.974.602l5.478 22.027 10.536 6.222-1.186-16.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB418",
    d: "M23.762 67.605c-.207.553-1.002.507-1.145-.066l-8.415-33.85L.908 25.84c-.504-.297-1.09.228-.853.763l23.337 52.6c.24.54 1.03.448 1.14-.132l5.07-26.982-.085.145L23.762 67.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE0732",
    d: "M23.762 67.605l5.755-15.362-2.52 4.27c-.3.508-1.076.324-1.117-.265l-1.14-16.33L14.2 33.7l8.415 33.84c.143.574.938.62 1.145.067"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F60",
    d: "M42.027 23.246L23.055.22c-.372-.45-1.103-.158-1.062.426l1.56 22.302 9.623 8.254c1.92 1.645 2.605 4.317 1.718 6.686l-5.26 14.04-.03.168 12.96-21.956c1.29-2.182 1.074-4.94-.537-6.894"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DE0733",
    d: "M27.544 41.576c2.18 1.288 3.32 3.806 2.853 6.298l-.762 4.053 5.26-14.04c.886-2.368.2-5.04-1.72-6.686l-9.623-8.25 1.186 16.97 2.806 1.66z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.517 52.265l.092-.157.03-.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M29.517 52.265l.092-.157.03-.18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC1D46",
    d: "M27.544 41.576l-2.806-1.656 1.142 16.328c.04.59.816.773 1.116.264l2.52-4.27.12-.315.76-4.053c.47-2.492-.672-5.01-2.852-6.298"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwinLogo);
export default __webpack_public_path__ + "static/media/AwinLogo.908800f61f1e99c9910f92bcf1e6946a.svg";
export { ForwardRef as ReactComponent };